<pcp-slide-sync-toolbar-button
    [matIcon]="matIconName"
    [fontSet]="fontSet"
    (click)="forward()"
    [disabled]="(isDisabled$ | async) === true"
></pcp-slide-sync-toolbar-button>
